import React from 'react';
import { observer } from 'mobx-react'
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import sha1 from 'sha1';
import { Button } from 'react-bootstrap'
import Config from '../config';
import Ds from '../stores/ds';
import { browserHistory } from 'react-router';

const ds = new Ds();

@observer(['invoices'])
class AssmanButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {}
    };
  }

  componentDidMount() {
    this.loadCompanyInfo();
  }

  async loadCompanyInfo() {
    // Get Company Info
    const query = `{
      company(id: ${this.props.companyId}, hash: "${localStorage.getItem('userHash')}") {
        id
        name
        assman_compid
        defaultContact {
          firstName
          lastName
          email
          phone
        }
        defaultBillingAddress {
          address
          city
          state
          zipCode
        }
      }
    }`;
    const company = await ds.queryPromise(query)
    .then(res => res.data.company);

    if (company) {
      this.setState({company});
    }
  }

  componentWillReceiveProps(props) {}

  async doAssmanImport(companyId) {
    const { company } = this.state;
    const password = sha1(company.defaultContact.firstName.trim()+company.defaultContact.lastName.trim());
    const mutation = gql`mutation addAccountUsingToken(
      $quicklogin_token: String!,
      $title: String!,
      $firstname: String!,
      $lastname: String!,
      $email: String!,
      $address: String!,
      $phone: String!,
      $username: String!,
      $password: String!,
      $timezone: String!
    ) {
      addAccountUsingToken(
        quicklogin_token: $quicklogin_token,
        title: $title,
        firstname: $firstname,
        lastname: $lastname,
        email: $email,
        address: $address,
        phone: $phone,
        username: $username,
        password: $password,
        timezone: $timezone
      )
    }`;
    const variables = {
      quicklogin_token: Config.assman_token,
      title: company.name,
      firstname: company.defaultContact.firstName,
      lastname: company.defaultContact.lastName,
      email: company.defaultContact.email,
      address: company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.state + ', ' + company.defaultBillingAddress.zipCode,
      phone: company.defaultContact.phone,
      username: company.defaultContact.email,
      password,
      timezone: 'America/Los_Angeles',
    };

    console.log('VARS:', variables);

    this.props.client.mutate({mutation, variables})
    .then((res) => {
      console.log('RES:', res);
      if (res.data.addAccountUsingToken) {
        ds.queryPromise(`mutation {
          updateCompany(id: ${companyId}, hash: "${localStorage.getItem('userHash')}", assman_compid: ${res.data.addAccountUsingToken}) {
            id
            name
            assman_compid
          }
        }`)
        .then((res) => {
          if (res) {
            console.log('SUCCESS:', res);

            this.loadCompanyInfo();

            if (this.props.onComplete) {
              this.props.onComplete();
            }
          }
        })
        .catch((err) => {
          console.error('Error updating company:', err);
        })
      } else {
        console.error('ERROR adding account to asset manager:', res);
      }
    })
    .catch((err) => {
      console.error('ERROR:', err);
    });
  }

  render() {
    return <Button
      bsSize="small"
      bsStyle="primary"
      onClick={() => {
        if (this.state.company.assman_compid) {
          browserHistory.push('/assetmanager/'+this.state.company.assman_compid);
        } else {
          if (confirm('Import into Asset Manager?')) {
            this.doAssmanImport(this.props.companyId);
          }
        }
      }}
    ><i className={this.state.company.assman_compid ? 'fa fa-info' : 'fa fa-cloud-upload'} aria-hidden={true} /> Asset Man.</Button>;
  }
}

export default withApollo(AssmanButton);


// WEBPACK FOOTER //
// ./src/utils/assmanbutton.js